"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EraRenderer = void 0;
var Renderer_1 = require("./Renderer");
var fabric_1 = require("fabric");
var chroma_js_1 = __importDefault(require("chroma-js"));
var HistoryCanvas_1 = require("../canvas/HistoryCanvas");
var luxon_1 = require("luxon");
var EraRenderer = /** @class */ (function (_super) {
    __extends(EraRenderer, _super);
    function EraRenderer(canvas, era) {
        var _this = _super.call(this, canvas) || this;
        _this.min_era_width_for_horizontal = HistoryCanvas_1.HistoryCanvas.calculateRelativeX(luxon_1.DateTime.fromISO('0001-01-01'), luxon_1.DateTime.fromISO('00031-01-01'));
        _this.name = era.name;
        _this.start = era.start;
        _this.end = era.end;
        _this.left = HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(era.start);
        _this.width = HistoryCanvas_1.HistoryCanvas.calculateRelativeX(era.start, era.end);
        return _this;
    }
    EraRenderer.prototype.render = function (offset, height, color) {
        var rect = new fabric_1.fabric.Rect({
            fill: color.brighten(0.2).alpha(0.1).hex(),
            stroke: color.brighten(0.1).alpha(0.3).hex(),
            strokeWidth: 2,
            left: this.left,
            width: this.width,
            top: offset,
            height: height
        });
        var isWideEnough = this.width > this.min_era_width_for_horizontal;
        var label = new fabric_1.fabric.Textbox(this.name, {
            left: this.left + this.width / 2,
            width: isWideEnough ? Math.min(rect.width, 300) : height,
            top: offset + height / 2,
            originX: 'center',
            originY: 'center',
            angle: isWideEnough ? 0 : 270,
            fontSize: this.LANE_HEIGHT,
            textAlign: 'center',
            strokeWidth: 0,
            fill: (0, chroma_js_1.default)('darkgray').hex()
        });
        var eraGlyph = new fabric_1.fabric.Group([rect, label], {
            tooltipText: "".concat(this.name, "\n").concat(this.start.year, " - ").concat(this.end.year),
            fill: color.hex()
        });
        var canvas = this.canvas;
        eraGlyph.on('mouseover', function () {
            rect.setOptions({
                stroke: (0, chroma_js_1.default)('grey').hex(),
            });
            canvas.requestRenderAll();
        });
        eraGlyph.on('mouseout', function () {
            rect.setOptions({
                stroke: color.brighten(0.1).alpha(0.3).hex(),
            });
            canvas.requestRenderAll();
        });
        this.canvas.add(eraGlyph);
    };
    return EraRenderer;
}(Renderer_1.Renderer));
exports.EraRenderer = EraRenderer;
